import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=b96f01f8&scoped=true&"
import script from "./ProductSettings.vue?vue&type=script&lang=js&"
export * from "./ProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProductSettings.vue?vue&type=style&index=0&id=b96f01f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96f01f8",
  null
  
)

export default component.exports